/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../organization-settings/organization.settings.model.ts" />

module Eseebase {
    export class LoginModel {
        email: string;
        password: string;
        fullName: string;
        accessToken: string;
        refreshToken: string;
        failed: boolean;
        rememberMe: boolean;
    }

    export class UserModel {
        id: string;
        email: string;
        name: string;
        phone: string;
        isSubscribed: boolean;
        organizationalUnitIds: string[];
        roles: string[];
        roleSelection: Role[];
        password: string;
        orgNumberSelection: string[];
        readOnly: boolean;
        companyNumber: string;
        companies: CompanyViewModel[];
        organizations: OrganizationalUnitViewModel[];
        defaultLanguage: string;
        type: string;
    }

    export class OrganizationalUnitViewModel {
        id: string;
        parent: OrganizationalUnitViewModel;
        parentId: string;
        name: string;
        number: string;
        companyName: string;
        companyNumber: string;
        companyId: string;
        children: OrganizationalUnitViewModel[];
        selected: boolean;
        settings: OrganizationSettingsModel[];
        inProgress: boolean;
        isNew: boolean;
        apartmentCount: number;
        hasFloorplans: boolean;
        hasFiles: boolean;
        tenderGroupId: string;
        isModified: boolean;
        ntiId: number;
    }

    export class CompanyViewModel {
        companyName: string;
        companyNumber: string;
        logicmediaId: string;
        ntiServerName: string;
        ntiApiKey: string;
        lbfCvr: string;
        lbfNo: string;
        lbfApiKey: string;
        lbfPpvApiKey: string;
        uiStyle: string;
        hasExternalRoles: string;
        caneaSyncEnabled: boolean;
        eseePlanEnabled: boolean;
        eseeDocEnabled: boolean;
        eseeSurveyEnabled: boolean;
        dawaAccessEnabled: boolean;
        autoForgeUploadEnabled: boolean;
    }

    export class Role {
        constructor(public name: string, public selected: boolean){}
    }
}